import { ThemeSpaceKeys } from "@agria/theme/src/styles/tokens/space";

interface TokenProps {
	borderRadius: ThemeSpaceKeys;
} 

export const tokens: TokenProps = {
	borderRadius: "xSmall",
};

export default tokens;
